/** * Created by liguochen on 2019/03/29 */
<template>
  <div class="paging_box" :class="{ paging_box_right: right }">
    <template v-if="handleSizeChange">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="currentPage.currentPage"
        prev-text="上一页"
        next-text="下一页"
        :layout="layout ? layout : 'prev, pager, next, total, jumper'"
        :total="Number(total)"
        :page-sizes="pageSizes"
        :page-size="currentPage.pageSize"
      >
      </el-pagination>
    </template>
    <template v-if="!handleSizeChange">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage.currentPage"
        prev-text="上一页"
        next-text="下一页"
        :layout="layout ? layout : 'prev, pager, next, total, jumper'"
        :total="Number(total)"
      >
      </el-pagination>
    </template>
  </div>
</template>

<script>
export default {
  name: "paging",
  // props: [
  //   "handleCurrentChange",
  //   "currentPage",
  //   "total",
  //   "right",
  //   "layout",
  //   "handleSizeChange",
  // ],
  props: {
    handleCurrentChange: Function,
    handleSizeChange: Function,
    currentPage: Object,
    total: [String, Number],
    right: String,
    layout: String,
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 50, 100];
      }
    }
  }
};
</script>

<style lang="scss">
.paging_box {
  float: right;
  margin-top: 16px;
  //   text-align: center;

  //   .number{
  //     color: #b6b6b6;
  //   }

  //   .active{
  //     // width: 20px;
  //     height: 20px;
  //     min-width: 20px;
  //     line-height: 20px;
  //     border-radius: 100%;
  //     color: #fff!important;
  //     background: #2ab1e8;
  //     margin-top: 3px;
  //     font-size: 14px;
  //     padding: 0;
  //   }

  //   .el-pagination__jump{
  //     margin-left: 0;
  //   }
  //   .el-pagination__sizes{
  //     .el-input{
  //       width: 90px;
  //     }
  //   }
  // }

  // .paging_box_right{
  //   text-align: right;
  //   padding-right: 30px;
  // }
  // .btn-prev span,.btn-next span {
  //   color: #2ab1e8;
}
</style>
